import _Object$assign from 'babel-runtime/core-js/object/assign';
import _extends from 'babel-runtime/helpers/extends';

import { mapState } from 'vuex';
import { format } from 'date-fns';
import { t } from '@/lang';
import { fmtSize } from '@com/utils/data-format';
import { playable, video, getPlansTitle, registerAlert, getStorageTime, getCount, hasNuit, checkPlanBalanceEnable } from '@pt/views/layout/plans-detail/plans-detail';
import { PlanType } from '@/common/permission';
import { formatDollar } from '@pt/views/account-management/utils';
import { subscribeConfirm } from '@pt/utils/subscribe';
import { isCNSuffix } from '@com/utils/url';
import GrantDialog from '@pt/components/grant-dialog/index.vue';
import { GrantOrderType } from '@pt/enums/grant';
import store from '@pt/store';
import { isEnterpriseUser } from '@pt/components/grant-dialog/utils';
import { PartnerApproveStatus } from '@pt/enums/partner';
import { showContractMessage } from '@pt/components/grant-dialog/utils';
import AccountFeedback from '@pt/components/account-feedback/index.vue';
import sendGtag from '@pt/utils/send-gtag.js';
import { handleTrial } from './utils';

export default {
  components: {
    GrantDialog: GrantDialog,
    AccountFeedback: AccountFeedback
  },
  data: function data() {
    return {
      packageDict: {
        1: playable,
        2: video,
        3: playable.concat(video)
      },
      PlanType: PlanType,
      isCNSuffix: isCNSuffix(),
      grantDialogVisible: false,
      accountType: 0,
      grantOrderType: GrantOrderType.Recharge,
      contactDialogVisible: false
    };
  },

  computed: _extends({}, mapState({
    userInfo: function userInfo(state) {
      return state.user.info;
    },
    balance: function balance(state) {
      return formatDollar(state.user.info.balance, '$ ');
    }
  }), {
    partnerInfo: function partnerInfo() {
      return store.state.user.partnerInfo;
    },
    isSubscribePage: function isSubscribePage() {
      return this.$route.name === 'common-template.subscribe';
    },
    showUserPlain: function showUserPlain() {
      if (!this.userInfo.plans) {
        return [];
      }
      var userList = this.userInfo.plans.map(function (item) {
        return _Object$assign(item, {
          expiredTime: format(item.expired_time * 1000, 'YYYY-MM-DD'),
          resetTime: format(item.reset_time * 1000, 'YYYY-MM-DD')
        });
      });
      return userList;
    },
    isShowTrial: function isShowTrial() {
      return Number(this.userInfo.trial_scope) === 3;
    },
    hasGrantRecord: function hasGrantRecord() {
      return this.userInfo.has_grant_record;
    },
    subscriptionPlan: function subscriptionPlan() {
      if (!this.userInfo.plans) {
        return;
      }
      return this.userInfo.plans.find(function (plan) {
        return plan.plan_type === PlanType.Subscription;
      });
    },
    userStorage: function userStorage() {
      if (this.userInfo.plans !== null && this.userInfo.storage.used_size !== null && this.userInfo.storage.total_size !== null) {
        return {
          usedSize: fmtSize(this.userInfo.storage.used_size),
          totalSize: fmtSize(this.userInfo.storage.total_size)
        };
      }
      return null;
    },
    subscribeButton: function subscribeButton() {
      return {
        type: 'text',
        disabled: this.isSubscribePage,
        class: 'subscribe-button'
      };
    }
  }),

  methods: {
    navigate: function navigate() {
      subscribeConfirm({
        title: t('playTurbo.account.subscribe.now'),
        content: t('playTurbo.account.subscribe.tips'),
        confirm: t('playTurbo.account.subscribe.title'),
        cancel: t('playTurbo.whole.cancel')
      });
    },
    userCategory: function userCategory() {
      if (isEnterpriseUser(this.partnerInfo.category)) {
        this.accountType = 1;
      }
    },
    getTitle: function getTitle(scope, planType) {
      return getPlansTitle(scope, planType);
    },
    getTime: function getTime(key) {
      return getStorageTime(this.showUserPlain, key);
    },
    pageDetail: function pageDetail() {
      this.$router.push({
        name: 'account-management.billing.usage'
      });
    },
    getCountHandle: function getCountHandle(num, compute) {
      return getCount(num, compute);
    },
    hasNuitHandle: function hasNuitHandle(num) {
      return hasNuit(num);
    },
    handTrial: function handTrial() {
      handleTrial();
    },
    handleRecharge: function handleRecharge() {
      this.grantOrderType = GrantOrderType.Recharge;
      this.grantDialogVisible = true;
    },
    handlePack: function handlePack() {
      var _this = this;

      if (this.$store.getters.partnerInfo.approve_status !== PartnerApproveStatus.Approved || !isEnterpriseUser(this.$store.getters.partnerInfo.category)) {
        showContractMessage().then(function (res) {
          if (res === 'confirm') {
            _this.contactDialogVisible = true;
          }
        });
        return;
      }

      this.grantOrderType = GrantOrderType.PackBuy;
      this.grantDialogVisible = true;
    },
    toPaymentList: function toPaymentList() {
      this.userCategory();

      sendGtag({
        name: 'purchase_start'
      });

      var url = this.$router.resolve({
        name: 'subscription-plans',
        query: { accountType: this.accountType }
      }).href;
      window.open(url, '_blank');
    },
    handleClose: function handleClose() {
      this.contactDialogVisible = false;
    }
  },
  mounted: function mounted() {
    this.$store.dispatch('GetUserPartnerInfo');
    // 套餐可用余额不足全局提示
    if (checkPlanBalanceEnable(this.showUserPlain)) {
      // 判断账号是否过期，每天只显示一次
      var isExpired = localStorage.getItem(this.userInfo.id + '_expired');

      if (isExpired === null || isExpired !== null && isExpired !== format(new Date(), 'YYYY-MM-DD')) {
        registerAlert(t('playTurbo.account.subscribe.otherTitle'), t('playTurbo.account.subscribe.otherDesc'));
        // 设置该账号过期的当天日期
        localStorage.setItem(this.userInfo.id + '_expired', format(new Date(), 'YYYY-MM-DD'));
      }
    }
  }
};